module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "namespace-form"
  }, [_c('h3', {
    staticClass: "title title-login"
  }, [_vm._v(_vm._s(_vm.$t('login.action.chooseYourTeam')))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group list-group-gap"
  }, _vm._l((_vm.teams), function(team, index) {
    return _c('li', {
      staticClass: "list-group-item bg-blue-grey-100"
    }, [_c('a', {
      staticClass: "btn btn-block btn-team text-xs-left media",
      attrs: {
        "ng-if": "team"
      },
      on: {
        "click": function($event) {
          _vm.selectTeam(team.namespace)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h4', {
      staticClass: "media-heading"
    }, [_c('span', {
      staticClass: "text-uppercase blue-600"
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" Team")]), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.baseURL + "/" + (team.namespace))))])]), _vm._v(" "), _vm._m(1, true)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "login-help"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('text.or')))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.loginOtherTeamClick
    }
  }, [_vm._v(_vm._s(_vm.$t('login.action.loginOtherTeam')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "avatar avatar-online"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/user.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-right align-middle"
  }, [_c('i', {
    staticClass: "icon md-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dfeee90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/TeamListForm.vue
// module id = 548
// module chunks = 1